import { HelpPage } from "./help-model";

const text = 
`
**Resumo das contas**

O resumo é sempre feito após a aplicação dos filtros e é um contador de contas de determinada classe.

- **Bad Status:** Contas com qualquer status diferente de ativo;
- **No Info:** A conta não tem informações para hoje ou o número de leads é igual a zero;
- **Leads:** Número de contas cujo o número de leads está abaixo do esperado para a data atual segundo a meta de leads;
- **Orçamento:** Contas cujo o investimento seja maior que 115% ou menor que 95% do orçamento mensal até a data atual;
- **Saldo:** Contas do tipo boleto cujo o saldo está abaixo do orçamento diário para 6 dias;


**Totais**

Estes números são uma soma dos dados de todas as contas visíveis após aplicar os filtros selecionados.

- **Total de Leads:** Soma dos de leads alcançados até o momento
- **Leads esperados:** 
- **Meta Total:** Soma da meta para o mês completo
- **Meta Performance:** Porcentagem atingida da meta mensal
- **Meta Proporcional:** Porcentagem atingida da meta mensal proporcional ao número de dias passados
- **Investimento:** Soma dos investimentos de todas as contas até agora`



export const welcomeHelp = {
    title: "Tela de boas vindas",
    body: text
} as HelpPage